import { useEffect, useState } from 'react'
import { subscribeToSalesByProduct } from './firebase'
import { computeBestSellers, type BestSellerOptions } from './bestSellers'

/**
 * Live set of product ids that currently qualify as best sellers, derived
 * automatically from real sales data. Returns an empty set until products
 * actually start selling, so a brand-new site tags nothing.
 */
export function useBestSellers(options?: BestSellerOptions): Set<string> {
  const [counts, setCounts] = useState<Record<string, number>>({})

  useEffect(() => {
    const unsub = subscribeToSalesByProduct(setCounts)
    return unsub
  }, [])

  return computeBestSellers(counts, options)
}
